import React, { useEffect, useState } from "react";
import "./HomeCollectionCss/AppoinmentBookingInfo.css";
import {
  formatDobDisplay,
  generateTimeRanges,
  showFieldError,
} from "../../utils/helper";
import { timeInterval } from "../../DB/TimeList";
import * as Yup from "yup";
import { getReferralDoctor, getTestList } from "../../api/api";
import toast from "react-hot-toast";
import ReferralDoctorModal from "./ReferralDoctorModal";
import { MdOutlineAttachFile } from "react-icons/md";
import useValidateForm from "../../Hooks/useValidateForm";
import { useCart } from "../../Contexts/Cart.contexts";
import HomeCollectionUpdate from "./HomeCollectionUpdate";
import { Button } from "@mui/material";
import { FiEdit2 } from "react-icons/fi";
import { FaUser, FaPhoneAlt, FaEnvelope, FaVenusMars } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import {
  MdDateRange,
  MdLocationOn,
  MdHome,
  MdLocationCity,
} from "react-icons/md";
import DatePicker from "react-datepicker";
import ShowTestModal from "./ShowTestModal";



const AppointmentBooking = ({
  formData,
  setFormData,
  setFormValid,
  onEditProfile,
  onEditAddress,
  allFieldsTouched,
  setAllFieldsTouched,
}) => {
  const timeList = generateTimeRanges(timeInterval);
  const [loading, setLoading] = useState(false);
  const [referralDoctorList, setReferralDoctorList] = useState([]);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [referralDoctorSearch, setReferralDoctorSearch] = useState("");
  const [touchedFields, setTouchedFields] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [testList, setTestList] = useState([]);
  const { cartItems } = useCart();
  const [doctorData, setDoctorData] = useState(null);
  const[viewTest,setViewTest]=useState(false);

  // ----------------------------- VALIDATION SCHEMA -----------------------------
  const bookingSchema = Yup.object({
    preferredDate: Yup.date()
      .required("Appointment date is required")
      .min(
        new Date().toISOString().split("T")[0],
        "Date cannot be in the past"
      ),
    preferredTime: Yup.string().required("Appointment time is required"),
    // ref_doctor: Yup.string().required("Referral doctor is required"),
    prescription: Yup.mixed()
      // .required("Prescription file is required")
      .test("fileType", "Only PDF, JPG, JPEG, PNG allowed", (value) => {
        if (!value) return true;
        const allowed = ["application/pdf", "image/jpeg", "image/png"];
        return allowed.includes(value.type);
      }),
  });

  // ----------------------------- VALIDATION HOOK -------------------------------
  const { isValid, fieldErrors } = useValidateForm(formData, bookingSchema);

  useEffect(() => {
    setFormValid(isValid);
  }, [isValid]);

  useEffect(() => {
    fetchTestListData();
  }, []);

  const getTomorrowDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    return today.toISOString().split("T")[0];
  };

  const getMaxDateAfter15Days = () => {
    const date = new Date();
    date.setDate(date.getDate() + 15);
    return date.toISOString().split("T")[0];
  };

  // ----------------------------- HANDLE INPUT CHANGE ---------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    setTouchedFields((prev) => ({ ...prev, [name]: true }));

    if (name === "preferredTime") {
      const [start, end] = value.split(" - ");
      setFormData((prev) => ({
        ...prev,
        preferredTime: value,
        Rtime: start?.trim() || "",
        APPToTime: end?.trim() || "",
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ----------------------------- FILE UPLOAD -----------------------------------
  const handlePrescriptionChange = (e) => {
    const file = e.target.files[0];

    setTouchedFields((prev) => ({ ...prev, prescription: true }));

    if (!file) return;

    const allowed = ["application/pdf", "image/jpeg", "image/png"];
    if (!allowed.includes(file.type)) {
      toast.error("Only PDF, JPG, JPEG, PNG allowed");
      return;
    }

    setFormData((prev) => ({ ...prev, prescription: file }));
  };

  // ----------------------------- REFERRAL MODAL --------------------------------
  const handleOpenReferral = () => setShowReferralModal(true);

  const handleReferralSelect = (doctor) => {
    setTouchedFields((prev) => ({ ...prev, ref_doctor: true }));

    setFormData((prev) => ({
      ...prev,
      ref_doctor: doctor.name,
      ref_doctorID: doctor.id,
      specialization: doctor.specialization,
      regNo: doctor.regNo,
    }));
    //   setDoctorData({
    //   name: doctor.name,
    //   id: doctor.id,

    // });
    console.log("doctorData is", doctorData);

    setShowReferralModal(false);
    setReferralDoctorSearch("");
  };

  const handleFindReferralDoctor = async (e) => {
    const value = e.target.value;
    setReferralDoctorSearch(value);

    if (value.length < 2) return;

    try {
      setLoading(true);
      const res = await getReferralDoctor({ name: value });
      setReferralDoctorList(res?.data?.data || []);
    } catch {
      toast.error("Error fetching doctors");
    } finally {
      setLoading(false);
    }
  };

  const handleModalShow = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleViewTests=()=>{
    setViewTest(true);
  }

  const fetchTestListData = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Center_ID: "",
      search_key: "",
    };
    try {
      setLoading(true);
      const res = await getTestList(payload);
      setTestList(res?.data?.data);
    } catch (error) {
      console.error("Error fetching test list:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="appointment-main">
      <div className="booking-form">
        <h2 className="form-heading-booking">Schedule Appointment</h2>

        <div className="form-grid">
          {/* Date */}
          <div className="booking-form-group">
            <input
              type="date"
              name="preferredDate"
              value={formData.preferredDate || ""}
              onChange={handleChange}
              // min={new Date().toISOString().split("T")[0]}
              min={getTomorrowDate()}
              max={getMaxDateAfter15Days()}
            />
            {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "preferredDate")) && (
              <span style={{ fontSize: "0.8rem", color: "red" }}>
                {fieldErrors.preferredDate}
              </span>
            )}
          </div>

          {/* Time */}
          <div className="booking-form-group">
            {/* <label>
              Appointment Time <span>*</span>
            </label> */}
            <select
              name="preferredTime"
              value={formData.preferredTime || ""}
              onChange={handleChange}
            >
              <option value="">-- Select Time Slot --</option>
              {timeList.map((t) => (
                <option key={t}>{t}</option>
              ))}
            </select>
            {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "preferredTime")) && (
              <span style={{ fontSize: "0.8rem", color: "red" }}>
                {fieldErrors.preferredTime}
              </span>
            )}
          </div>
        </div>

        {/* Buttons */}
        {/* <div className="form-grid button-row">
          <div>
          <button
            type="button"
            className="action-btn"
            onClick={handleOpenReferral}
          >
            Choose Referral Doctor
          </button>
           {formData.ref_doctor && !fieldErrors.ref_doctor && (
            <span style={{ color: "green",fontSize:'0.8rem' }}>{formData.ref_doctor}</span>
          )}
          </div>

          {(allFieldsTouched ||
            showFieldError(touchedFields, fieldErrors, "ref_doctor")) && (
            <span style={{ fontSize: "0.8rem", color: "red" }}>
              {fieldErrors.ref_doctor}
            </span>
          )}

          <button
            type="button"
            className="action-btn"
            onClick={() =>
              document.getElementById("prescriptionUpload").click()
            }
          >
            <MdOutlineAttachFile /> Upload Prescription
          </button>

          <input
            type="file"
            id="prescriptionUpload"
            name="prescription"
            accept=".pdf,.jpg,.jpeg,.png"
            style={{ display: "none" }}
            onChange={handlePrescriptionChange}
          />

          {(allFieldsTouched ||
            showFieldError(touchedFields, fieldErrors, "prescription")) && (
            <span style={{ fontSize: "0.8rem", color: "red" }}>
              {fieldErrors.prescription}
            </span>
          )}

          {formData.prescription && !fieldErrors.prescription && (
            <span style={{ color: "green" }}>{formData.prescription.name}</span>
          )}
        </div> */}
        <div className="frist-row-grid">
          {/* Referral Doctor Section */}
          <div className="booking-form-group full-width">
  {/* Always present wrapper */}
  <div className="margin-top-5 margin-bottom-5 custom-data-box">
    {formData.ref_doctor && !fieldErrors.ref_doctor && (
      <>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {`Dr. ${formData?.ref_doctor}`}
        </p>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {`Reg No: ${formData?.regNo}`}
        </p>
        <p
          className="p-nomargin"
          style={{ color: "green", fontSize: "0.8rem" }}
        >
          {formData?.specialization}
        </p>
      </>
    )}
  </div>

  <button
    type="button"
    className="action-btn"
    onClick={handleOpenReferral}
  >
    Choose Referral Doctor
  </button>

  {/* {(allFieldsTouched ||
    showFieldError(touchedFields, fieldErrors, "ref_doctor")) && (
    <span style={{ fontSize: "0.8rem", color: "red" }}>
      {fieldErrors.ref_doctor}
    </span>
  )} */}
</div>


          {/* Prescription Upload Section */}
          <div className="booking-form-group full-width">
            <div className="margin-bottom-5 margin-top-5 custom-data-box">
              {formData.prescription && !fieldErrors.prescription && (
                <span style={{ color: "green", fontSize: "0.8rem" }}>
                  {formData.prescription.name}
                </span>
              )}
            </div>
            <button
              type="button"
              className="action-btn"
              onClick={() =>
                document.getElementById("prescriptionUpload").click()
              }
            >
              <MdOutlineAttachFile size={14} /> Upload Prescription
            </button>

            <input
              type="file"
              id="prescriptionUpload"
              name="prescription"
              accept=".pdf,.jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={handlePrescriptionChange}
            />

            {/* {(allFieldsTouched ||
              showFieldError(touchedFields, fieldErrors, "prescription")) && (
              <span style={{ fontSize: "0.8rem", color: "red" }}>
                {fieldErrors.prescription}
              </span>
            )} */}
          </div>
          <div>
            <div className="margin-bottom-5 margin-top-5 custom-data-box">
              {cartItems?.length > 0 ? (
                <>
                  <div>
                    <span style={{ color: "green", fontSize: "0.8rem" }}>
                      Selected Test : {cartItems.length}
                    </span>
                  </div>
                  <div>
                    <span style={{ color: "green", fontSize: "0.8rem" }}>
                      Total Price : ₹
                      {cartItems.reduce(
                        (sum, item) => sum + (Number(item.price) || 0),
                        0
                      )}
                    </span>
                     <div>
                     <button className="booking-edit-btn" onClick={handleViewTests} >
                     
                      <FaRegEye />View
                     
                      </button>
                      </div>
                  </div>
                 
                </>
              ) : (
                <span style={{ fontSize: "0.8rem", color: "#999" }}>
                  {/* No tests selected */}
                </span>
              )}
            </div>

            <button
              type="button"
              className="action-btn"
              onClick={handleModalShow}
            >
              Select / Update Tests
            </button>
          </div>
        </div>

        {/* {cartItems?.length > 0 && ( */}
        {/* <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
          {cartItems?.length > 0 && (
            <>
              <p>selected Test : {cartItems.length}</p>
              <p>
                Total Price : ₹
                {cartItems.reduce(
                  (sum, item) => sum + (Number(item.price) || 0),
                  0
                )}
              </p>
            </>
          )}
          <Button sx={{ color: "#009688" }} onClick={handleModalShow}>
            Select/Update Tests
          </Button>
        </div> */}
        {/* )} */}
      </div>

      {/* ---------------------- COMBINED INFO CARD --------------------- */}
      <div
        className="booking-info-box"
        style={{
          border: "1px solid #ddd",
          borderRadius: "12px",

          background: "#fff",
          width: "100%",
        }}
      >
        {/* ---------- HEADER ---------- */}
        <div
          className="info-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <h3 style={{ margin: 0 }}>User Information</h3> */}

          {/* <div style={{ display: "flex", gap: "10px" }}>
      <button className="booking-edit-btn" onClick={onEditProfile}>
        ✏️ Edit Basic Info
      </button>
      <button className="booking-edit-btn" onClick={onEditAddress}>
        ✏️ Edit Address
      </button>
    </div> */}
        </div>

        {/* ---------- BASIC INFORMATION SECTION ---------- */}
        <div style={{}}>
          <div className="basic-info-header">
            <h4>Basic Information</h4>

            <button className="booking-edit-btn" onClick={onEditProfile}>
              <FiEdit2 className="edit-icon" />
              Edit
            </button>
          </div>

          <div className="booking-info-item">
            <FaUser className="info-icon" />
            <span className="booking-info-value">
              {formData.PFirstName} {formData.PLastName}
            </span>
          </div>

          {/* Gender */}
          {formData?.PSex && (
            <div className="booking-info-item">
              <FaVenusMars className="info-icon" />
              <span className="booking-info-value">
                {formData.PSex === "M" ? "Male" : "Female"}
              </span>
            </div>
          )}

          {/* Mobile */}
          {formData?.mobile_no && (
            <div className="booking-info-item">
              <FaPhoneAlt className="info-icon" />
              <span className="booking-info-value">{formData.mobile_no}</span>
            </div>
          )}

          {/* DOB */}
          <div className="booking-info-item">
            <MdDateRange className="info-icon" />
            <span className="booking-info-value">
              {formatDobDisplay(formData.dateofbirth)}
            </span>
          </div>

          {/* Email */}
          {formData?.email && (
            <div className="booking-info-item">
              <FaEnvelope className="info-icon" />
              <span className="booking-info-value">{formData.email}</span>
            </div>
          )}
        </div>

        {/* ---------- DIVIDER ---------- */}
        <hr style={{ borderTop: "1px solid #ccc" }} />

        {/* ---------- ADDRESS INFORMATION SECTION ---------- */}
        <div>
          <div className="basic-info-header">
            <h4>Address Information</h4>

            <button className="booking-edit-btn" onClick={onEditAddress}>
              <FiEdit2 className="edit-icon" />
              Edit
            </button>
          </div>

          {/* {["address", "State", "City", "Zipcode", "landmark"].map((field) => (
            <div className="booking-info-item" key={field}>
              <span className="booking-info-value">{formData[field]}</span>
            </div>
          ))} */}
          <div className="booking-info-item">
            <MdHome className="info-icon" />
            <span className="booking-info-value">{formData.address}</span>
          </div>

          <div className="booking-info-item">
            <MdLocationCity className="info-icon" />
            <span className="booking-info-value">{formData.City}</span>
          </div>

          <div className="booking-info-item">
            <MdLocationCity className="info-icon" />
            <span className="booking-info-value">{formData.State}</span>
          </div>

          <div className="booking-info-item">
            <MdLocationOn className="info-icon" />
            <span className="booking-info-value">{formData.Zipcode}</span>
          </div>
          {formData.landmark && (
            <div className="booking-info-item">
              <MdLocationOn className="info-icon" />
              <span className="booking-info-value">{formData.landmark}</span>
            </div>
          )}
        </div>
      </div>

      {/* <img className="doctor-img" src={img} alt="Doctor" /> */}

      {showModal && (
        <HomeCollectionUpdate
          onClose={handleModalClose}
          testList={testList}
          setTestList={setTestList}
          setToggle={setToggle}
        />
      )}

      {showReferralModal && (
        <ReferralDoctorModal
          onClose={() => setShowReferralModal(false)}
          onChange={handleFindReferralDoctor}
          referralDoctorList={referralDoctorList}
          referralDoctor={referralDoctorSearch}
          onSelect={handleReferralSelect}
        />
      )}
    {viewTest && <ShowTestModal open={viewTest} onClose={() => setViewTest(false)}  tests={cartItems} />  }

    </div>
  );
};

export default AppointmentBooking;
